/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackDownloadCountResponseData
 */
export interface TrackDownloadCountResponseData {
    /**
     * Track ID (hash)
     * @type {string}
     * @memberof TrackDownloadCountResponseData
     */
    id: string;
    /**
     * Full track + all stems (parent) or stem-only (stem)
     * @type {number}
     * @memberof TrackDownloadCountResponseData
     */
    downloadCount: number;
}

/**
 * Check if a given object implements the TrackDownloadCountResponseData interface.
 */
export function instanceOfTrackDownloadCountResponseData(value: object): value is TrackDownloadCountResponseData {
    let isInstance = true;
    isInstance = isInstance && "id" in value && value["id"] !== undefined;
    isInstance = isInstance && "downloadCount" in value && value["downloadCount"] !== undefined;

    return isInstance;
}

export function TrackDownloadCountResponseDataFromJSON(json: any): TrackDownloadCountResponseData {
    return TrackDownloadCountResponseDataFromJSONTyped(json, false);
}

export function TrackDownloadCountResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackDownloadCountResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'downloadCount': json['download_count'],
    };
}

export function TrackDownloadCountResponseDataToJSON(value?: TrackDownloadCountResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'download_count': value.downloadCount,
    };
}

